import { createFileRoute } from '@tanstack/react-router'
import { CrewDirectory } from '@/components/CrewDirectory'
import { z } from 'zod'

const crewDirectorySearchSchema = z.object({
  search: z.string().optional(),
})

export const Route = createFileRoute('/_auth/crew-directory/')({
  validateSearch: crewDirectorySearchSchema,
  component: CrewDirectoryRoute,
})

function CrewDirectoryRoute() {
  const { search } = Route.useSearch()

  return <CrewDirectory initialSearch={search} basePath="/crew-directory" />
}
